import { observer } from "mobx-react-lite";

// hooks
import { useLzsrStore } from "../../../../../../../store/hooks";

// types
import { EnAreaNames, EnFormNames, } from "../../../../../../../store/caseSettingsStore";

// components
import { TopViewCase } from "../../topViewCase/TopViewCase";
import { UserLayout } from "../../../../../../shared/user/layout/UserLayout";
import { PatientSection } from "./patientSection/PatientSection";

// lib
import { useViewCase } from "../../../viewCaseCreator/useViewCase";
import { CurrentTreatmentSection } from "./currentTreatmentSection/CurrentTreatmentSection";
import { TreatmentProgramSection } from "./treatmentProgramSection/TreatmentProgramSection";
import { Observations } from "./obervations/Observations";


export const LzsrViewCase = observer(() => {
  const lzsrStore = useLzsrStore();
  const {isCase} = useViewCase(
    EnAreaNames.rheumatology,
    EnFormNames.lzsr,
    lzsrStore
  );

  return (
    <UserLayout>
      {isCase && (
        <>
          <TopViewCase caseStore={lzsrStore}/>
          <PatientSection/>
          <CurrentTreatmentSection/>
          <TreatmentProgramSection/>
          <Observations/>
        </>
      )}
    </UserLayout>
  );
});
